import { catchAsync } from './index.js';
import UserAPI from './user.js';

class TradenameAPIService {
    getByPage = catchAsync(async (page = 1, limit = 10) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/tradenames?page=${page}&limit=${limit}`);

        const data = await res.json();
        return data;
    });

    search = catchAsync(async (keyword, page = 1, limit = 10) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/search/tradenames?keyword=${encodeURIComponent(keyword)}&page=${page}&limit=${limit}`);

        const data = await res.json();
        return data;
    });

    getOne = catchAsync(async (uri) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/tradenames/${uri}`);

        const data = await res.json();
        return data;
    });

    create = catchAsync(async (tradename) => {
        const token = UserAPI.getUserToken();

        if (!token) {
            return null;
        }

        const res = await fetch(`${process.env.REACT_APP_API_URL}/tradenames/create`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(tradename),
        });

        const data = await res.json();
        return data;
    });

    edit = catchAsync(async (id, tradename) => {
        const token = UserAPI.getUserToken();

        if (!token) {
            return null;
        }

        const res = await fetch(`${process.env.REACT_APP_API_URL}/tradenames/update/${id}`, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(tradename),
        });

        const data = await res.json();
        return data;
    });

    delete = catchAsync(async (id) => {
        const token = UserAPI.getUserToken();

        if (!token) {
            return null;
        }

        const res = await fetch(`${process.env.REACT_APP_API_URL}/tradenames/delete/${id}`, {
            method: "DELETE",
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        });

        const data = await res.json();
        return data;
    });

    async getAll() {
        return catchAsync(async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/tradenames`);
            if (!response.ok) throw new Error('Failed to fetch tradenames');
            return await response.json();
        });
    }

    async getManufacturersByUri(uri) {
        return catchAsync(async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/tradenames/${uri}/manufacturers`);
            if (!response.ok) throw new Error(`Failed to fetch manufacturers for tradename ${uri}`);
            return await response.json();
        });
    }
}

const TradenameAPI = new TradenameAPIService();
export default TradenameAPI; 